import { Modal, Spin, Table } from 'antd';
import { ColumnsType } from 'antd/lib/table';
import _ from 'lodash';
import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { Dispatch } from 'redux';
import IInvestmentTransaction from '~Api/Investment/IInvestmentTransaction';
import IInvestorAccountInvestmentTransaction from '~Api/Investor/IInvestorAccountInvestmentTransaction';
import {
    investmentTransactionGetAction,
    investmentTransactionInvestorsListAction,
} from '~Investments/actions';
import {
    investmentTransactionInvestorsSelector,
    investmentTransactionSelector,
} from '~Investments/selectors';
import { IGlobalState } from '~reducer';
import { currencyFormatter } from '~utilities/formatters';
import { IDictionary } from '~utilities/IDictionary';

interface IProps {
    investmentTransactionUuid: string;
    isOpen: boolean;
    onCancel: () => void;
}

interface IPropsSelector {
    investorTransactions: IDictionary<IInvestorAccountInvestmentTransaction>;
    transaction: IInvestmentTransaction;
}

interface IPropsDispatch {
    investorTransactionsList: () => void;
    transactionGet: () => void;
}

type Props = IProps & IPropsSelector & IPropsDispatch;

class TransactionModal extends React.Component<Props> {
    constructor(props: Props) {
        super(props);

        this.summary = this.summary.bind(this);
    }

    public componentDidMount(): void {
        const { investorTransactions, transaction } = this.props;

        if (!investorTransactions) {
            this.props.investorTransactionsList();
        }

        if (!transaction) {
            this.props.transactionGet();
        }
    }

    public render(): JSX.Element {
        const { investorTransactions, isOpen, transaction } = this.props;

        if (!investorTransactions || !transaction) {
            return (
                <Modal
                    footer={false}
                    onCancel={this.props.onCancel}
                    open={isOpen}
                    title='Transaction Details'
                    width={1000}
                >
                    <Spin/>
                </Modal>
            );
        }

        const columns: ColumnsType<IInvestorAccountInvestmentTransaction> = [
            {
                defaultSortOrder: 'ascend',
                render: (transaction: IInvestorAccountInvestmentTransaction) => <Link to={`/investors/${transaction.investorUuid}`}>{transaction.investorAccount.investorName}</Link>,
                sorter: (a: IInvestorAccountInvestmentTransaction, b: IInvestorAccountInvestmentTransaction) => {
                    return a.investorAccount.investorName.localeCompare(b.investorAccount.investorName);
                },
                title: 'Investor',
            },
            {
                dataIndex: 'principalAmount',
                render: (principalAmount: number) => currencyFormatter.format(principalAmount),
                sorter: (a: IInvestorAccountInvestmentTransaction, b: IInvestorAccountInvestmentTransaction) => {
                    return a.principalAmount > b.principalAmount ? 1 : -1;
                },
                title: 'Principal',
                width: '20%',
            },
            {
                dataIndex: 'interestAmount',
                render: (interestAmount: number) => currencyFormatter.format(interestAmount),
                sorter: (a: IInvestorAccountInvestmentTransaction, b: IInvestorAccountInvestmentTransaction) => {
                    return a.interestAmount > b.interestAmount ? 1 : -1;
                },
                title: 'Interest',
                width: '20%',
            },
        ];

        return (
            <Modal
                footer={false}
                onCancel={this.props.onCancel}
                open={isOpen}
                title='Transaction Details'
                width={1000}
            >
                <Table
                    columns={columns}
                    dataSource={_.values(investorTransactions)}
                    pagination={false}
                    rowKey='uuid'
                    size='middle'
                    summary={this.summary}
                />
            </Modal>
        );
    }

    private summary(): JSX.Element {
        const { investorTransactions } = this.props;

        let investorCount: number = 0;
        let principalTotal: number = 0;
        let interestTotal: number = 0;

        _.forEach(investorTransactions, (investorTransaction: IInvestorAccountInvestmentTransaction) => {
            investorCount++;
            principalTotal += investorTransaction.principalAmount;
            interestTotal += investorTransaction.interestAmount;
        });

        return (
            <Table.Summary.Row>
                <Table.Summary.Cell index={0}><strong>{investorCount}</strong></Table.Summary.Cell>
                <Table.Summary.Cell index={1}><strong>{currencyFormatter.format(principalTotal)}</strong></Table.Summary.Cell>
                <Table.Summary.Cell index={2}><strong>{currencyFormatter.format(interestTotal)}</strong></Table.Summary.Cell>
            </Table.Summary.Row>
        );
    }
}

function mapStateToProps(state: IGlobalState, ownProps: IProps): IPropsSelector {
    return {
        investorTransactions: investmentTransactionInvestorsSelector(state, ownProps.investmentTransactionUuid),
        transaction: investmentTransactionSelector(state, ownProps.investmentTransactionUuid),
    };
}

function mapDispatchToProps(dispatch: Dispatch, ownProps: IProps): IPropsDispatch {
    return {
        investorTransactionsList: () => dispatch(investmentTransactionInvestorsListAction(ownProps.investmentTransactionUuid)),
        transactionGet: () => dispatch(investmentTransactionGetAction(ownProps.investmentTransactionUuid)),
    };
}

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(TransactionModal);
